<template>
    <nav class="bg-black px-2 md:px-4 py-2 fixed w-full z-50 max-h-[75px]">
        <div class="md:px-16 flex flex-wrap justify-between items-center mx-auto">
            <a href="/" class="flex items-center">
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="83.6"
                    height="44.857"
                    viewBox="0 0 83.6 44.857"
                >
                    <g id="dkilo_logo" data-name="dkilo logo" transform="translate(-40 -31.124)">
                        <g
                            id="white_dkilo_logo"
                            data-name="white dkilo logo"
                            transform="translate(40 31.124)"
                        >
                            <g id="c">
                                <g id="Group_15925" data-name="Group 15925">
                                    <g
                                        id="Group_15922"
                                        data-name="Group 15922"
                                        transform="translate(25.466 5.216)"
                                    >
                                        <g
                                            id="Group_15921"
                                            data-name="Group 15921"
                                            transform="translate(19.472 4.583)"
                                        >
                                            <rect
                                                id="Rectangle_1838"
                                                data-name="Rectangle 1838"
                                                width="5.216"
                                                height="5.216"
                                                transform="translate(5.216) rotate(90)"
                                                fill="#fff"
                                            />
                                            <path
                                                id="Path_25624"
                                                data-name="Path 25624"
                                                d="M182.8,85.83v22.484H177.61V85.83Z"
                                                transform="translate(-177.597 -73.907)"
                                                fill="#fff"
                                            />
                                        </g>
                                        <path
                                            id="Path_25625"
                                            data-name="Path 25625"
                                            d="M213.633,20.61V59.6H208.44V20.61Z"
                                            transform="translate(-181.152 -20.61)"
                                            fill="#fff"
                                        />
                                        <path
                                            id="Path_25626"
                                            data-name="Path 25626"
                                            d="M235.55,95.065a11.177,11.177,0,0,1,3.485-8.289,12.3,12.3,0,0,1,17.038.023,12.041,12.041,0,0,1-.023,16.921,11.91,11.91,0,0,1-8.61,3.394,11.381,11.381,0,0,1-8.473-3.462,11.645,11.645,0,0,1-3.417-8.587Zm5.31.091a7.586,7.586,0,0,0,1.8,5.333,7,7,0,0,0,9.744.023,8.44,8.44,0,0,0,0-10.483,6.341,6.341,0,0,0-4.872-1.984,6.233,6.233,0,0,0-4.824,1.984,7.22,7.22,0,0,0-1.848,5.125Z"
                                            transform="translate(-201.401 -67.479)"
                                            fill="#fff"
                                        />
                                        <path
                                            id="Path_25627"
                                            data-name="Path 25627"
                                            d="M110.339,46.556l9.764-9.443H113.13l-7.317,7.271V20.61h-2.584v2.609H100.62V59.6h5.193V50.942l.833-.83,7.433,9.488h6.742l-10.48-13.044Z"
                                            transform="translate(-100.62 -20.61)"
                                            fill="#fff"
                                        />
                                    </g>
                                    <g id="Group_15924" data-name="Group 15924">
                                        <g
                                            id="Group_15923"
                                            data-name="Group 15923"
                                            transform="translate(0 2.609)"
                                        >
                                            <path
                                                id="Path_25628"
                                                data-name="Path 25628"
                                                d="M17.638,23.219V39.726a9.71,9.71,0,0,0-14.611.162A12.1,12.1,0,0,0,0,48.29a12.674,12.674,0,0,0,3.024,8.59,9.889,9.889,0,0,0,7.663,3.371,9.689,9.689,0,0,0,6.95-3V59.6h5.219V25.826H20.247V23.217H17.638Zm-1.453,30.4a5.964,5.964,0,0,1-4.664,1.987,5.68,5.68,0,0,1-4.48-2.055A7.836,7.836,0,0,1,5.31,48.29a7.489,7.489,0,0,1,1.779-5.079,5.74,5.74,0,0,1,4.48-2.03,5.868,5.868,0,0,1,4.616,2.01,7.687,7.687,0,0,1,1.777,5.216,7.694,7.694,0,0,1-1.777,5.219ZM22.856,20.61H20.247v2.609h2.609Z"
                                                transform="translate(0 -18.003)"
                                                fill="#369da3"
                                            />
                                            <rect
                                                id="Rectangle_1839"
                                                data-name="Rectangle 1839"
                                                width="2.609"
                                                height="2.609"
                                                transform="translate(17.638)"
                                                fill="#369da3"
                                            />
                                            <rect
                                                id="Rectangle_1840"
                                                data-name="Rectangle 1840"
                                                width="2.609"
                                                height="2.609"
                                                transform="translate(22.856)"
                                                fill="#369da3"
                                            />
                                        </g>
                                        <rect
                                            id="Rectangle_1841"
                                            data-name="Rectangle 1841"
                                            width="2.609"
                                            height="2.609"
                                            transform="translate(28.075)"
                                            fill="#369da3"
                                        />
                                    </g>
                                </g>
                            </g>
                        </g>
                    </g>
                </svg>
            </a>
            <div class="flex items-center gap-10 md:order-2">
                <!-- <div>
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="41"
                        height="41"
                        viewBox="0 0 41 41"
                    >
                        <g
                            id="Group_16639"
                            data-name="Group 16639"
                            transform="translate(-1158 -27.857)"
                        >
                            <circle
                                id="Ellipse_1204"
                                data-name="Ellipse 1204"
                                cx="20.5"
                                cy="20.5"
                                r="20.5"
                                transform="translate(1158 27.857)"
                                fill="none"
                            />
                            <g
                                id="Group_2635"
                                data-name="Group 2635"
                                transform="translate(1164.19 33.887)"
                            >
                                <g
                                    id="svgexport-6_94_"
                                    data-name="svgexport-6 (94)"
                                    transform="translate(0)"
                                >
                                    <g
                                        id="Group_2633"
                                        data-name="Group 2633"
                                        transform="translate(0 0)"
                                    >
                                        <g
                                            id="Group_2632"
                                            data-name="Group 2632"
                                            transform="translate(0 0)"
                                        >
                                            <path
                                                id="Path_25580"
                                                data-name="Path 25580"
                                                d="M37.968,16.345V11.435A8.594,8.594,0,0,0,32.42,3.418a2.917,2.917,0,0,0,.058-.571,2.847,2.847,0,1,0-5.694,0,3.048,3.048,0,0,0,.054.554,8.331,8.331,0,0,0-5.544,7.854v5.09a.33.33,0,0,1-.329.329,2.991,2.991,0,0,0-2.993,2.635,2.919,2.919,0,0,0,2.906,3.2H25.9a3.75,3.75,0,0,0,7.454,0h5.027a2.919,2.919,0,0,0,2.906-3.2A2.994,2.994,0,0,0,38.3,16.675a.327.327,0,0,1-.329-.329ZM29.631,1.667a1.181,1.181,0,0,1,1.18,1.18,1.019,1.019,0,0,1-.017.158,7.388,7.388,0,0,0-.859-.079,8.59,8.59,0,0,0-1.467.083,1.02,1.02,0,0,1-.017-.158,1.182,1.182,0,0,1,1.18-1.184Zm0,22.511a2.091,2.091,0,0,1-2.043-1.667h4.085A2.091,2.091,0,0,1,29.631,24.178Zm10-4.711a1.246,1.246,0,0,1-1.246,1.376H20.877a1.252,1.252,0,0,1-1.246-1.376,1.31,1.31,0,0,1,1.334-1.126,2,2,0,0,0,2-2v-5.09a6.673,6.673,0,0,1,6.67-6.67c.083,0,.163,0,.246,0A6.82,6.82,0,0,1,36.3,11.435v4.911a2,2,0,0,0,2,2A1.313,1.313,0,0,1,39.631,19.468Z"
                                                transform="translate(-17.958 0)"
                                                fill="#fff"
                                            />
                                        </g>
                                    </g>
                                </g>
                                <g
                                    id="Group_2634"
                                    data-name="Group 2634"
                                    transform="translate(12.855 12.637)"
                                >
                                    <circle
                                        id="Ellipse_1"
                                        data-name="Ellipse 1"
                                        cx="7.811"
                                        cy="7.811"
                                        r="7.811"
                                        transform="translate(0 0)"
                                        fill="#ca4e59"
                                    />
                                    <text
                                        id="_2"
                                        data-name="2"
                                        transform="translate(5.807 10.605)"
                                        fill="#fff"
                                        font-size="8"
                                        font-family="ArticulatCF-Medium, Articulat CF"
                                        font-weight="500"
                                    >
                                        <tspan x="0" y="0">2</tspan>
                                    </text>
                                </g>
                            </g>
                        </g>
                    </svg>
                </div> -->
                <div class="hidden md:flex items-center gap-1 cursor-pointer">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="30"
                        height="30"
                        viewBox="0 0 30 30"
                    >
                        <g
                            id="support_icon"
                            data-name="support icon"
                            transform="translate(-1026 -30)"
                        >
                            <circle
                                id="Ellipse_1204"
                                data-name="Ellipse 1204"
                                cx="15"
                                cy="15"
                                r="15"
                                transform="translate(1026 30)"
                                fill="none"
                            />
                            <path
                                id="headset"
                                d="M18.437,11.151V9.9a7.9,7.9,0,0,0-15.8,0v1.25a4.389,4.389,0,0,0,1.756,8.406A1.756,1.756,0,0,0,6.147,17.8V12.534a1.756,1.756,0,0,0-1.756-1.756V9.9a6.145,6.145,0,1,1,12.29,0v.878a1.756,1.756,0,0,0-1.756,1.756V17.8H12.292a.878.878,0,0,0,0,1.756h4.389a4.389,4.389,0,0,0,1.756-8.406ZM4.391,17.8h0a2.634,2.634,0,1,1,0-5.267Zm12.29,0V12.534a2.634,2.634,0,1,1,0,5.267Z"
                                transform="translate(1029.986 34)"
                                fill="#fff"
                            />
                        </g>
                    </svg>
                    <p class="text-white mb-0" @click="goTo()">Support</p>
                </div>

                <div class="relative text-lg w-[95px] md:min-w-[143px]">
                    <button
                        class="flex items-center justify-around px-0 py-1 text-white w-full rounded-lg"
                        @click="isOptionsExpanded = !isOptionsExpanded"
                        @blur="isOptionsExpanded = false"
                    >
                        <div class="w-[40px] h-[40px] bg-white rounded-full mr-1">
                            <svg
                                class="flex items-center justify-center mx-auto w-[95%] h-[95%]"
                                xmlns="http://www.w3.org/2000/svg"
                                width="35"
                                height="35"
                                viewBox="0 0 35 35"
                            >
                                <g
                                    id="Group_16106"
                                    data-name="Group 16106"
                                    transform="translate(-683 -223)"
                                >
                                    <circle
                                        id="Ellipse_1210"
                                        data-name="Ellipse 1210"
                                        cx="17.5"
                                        cy="17.5"
                                        r="17.5"
                                        transform="translate(683 223)"
                                        fill="none"
                                        opacity="0.3"
                                    />
                                    <g
                                        id="user_3_"
                                        data-name="user (3)"
                                        transform="translate(690 231)"
                                    >
                                        <path
                                            id="Path_25867"
                                            data-name="Path 25867"
                                            d="M10.9,9.8A4.9,4.9,0,1,0,6,4.9a4.9,4.9,0,0,0,4.9,4.9Zm0-8.167A3.267,3.267,0,1,1,7.633,4.9,3.267,3.267,0,0,1,10.9,1.633Z"
                                            transform="translate(-0.55)"
                                        />
                                        <path
                                            id="Path_25868"
                                            data-name="Path 25868"
                                            d="M10.35,14A7.358,7.358,0,0,0,3,21.35a.817.817,0,1,0,1.633,0,5.717,5.717,0,1,1,11.433,0,.817.817,0,0,0,1.633,0A7.358,7.358,0,0,0,10.35,14Z"
                                            transform="translate(0 -2.567)"
                                        />
                                    </g>
                                </g>
                            </svg>
                        </div>
                        <span class="hidden md:flex text-sm capitalize">
                            {{ isfirstName }}
                        </span>

                        <svg
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                            class="hidden md:flex h-4 w-4 transform transition-transform duration-200 ease-in-out"
                            :class="isOptionsExpanded ? 'rotate-180' : 'rotate-0'"
                        >
                            <path
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="2"
                                d="M19 9l-7 7-7-7"
                            />
                        </svg>
                    </button>
                    <transition
                        enter-active-class="transform transition duration-500 ease-custom"
                        enter-class="-translate-y-1/2 scale-y-0 opacity-0"
                        enter-to-class="translate-y-0 scale-y-100 opacity-100"
                        leave-active-class="transform transition duration-300 ease-custom"
                        leave-class="translate-y-0 scale-y-100 opacity-100"
                        leave-to-class="-translate-y-1/2 scale-y-0 opacity-0"
                    >
                        <ul
                            v-show="isOptionsExpanded"
                            class="absolute left-0 right-0 mb-4 bg-white divide-y rounded-lg shadow-lg overflow-hidden"
                        >
                            <li
                                v-for="(option, index) in options"
                                :key="index"
                                class="px-3 py-2 transition-colors duration-300 hover:bg-gray-200 cursor-pointer"
                                @click="setOption(option)"
                            >
                                {{ option }}
                            </li>
                        </ul>
                    </transition>
                </div>
            </div>
            <div
                class="hidden justify-around -ml-[15%] pt-1 bg-black items-center w-[50%] md:flex md:w-auto md:order-1"
                id="mobile-menu-2"
            >
                <ul
                    class="hidden p-4 mt-4 bg-black lg:flex xl:gap-[60px] lg:flex-row lg:space-x-12 lg:mt-0 lg:text-[18px] lg:font-normal lg:border-0 lg:bg-black"
                >
                    <li>
                        <a
                            href="/"
                            class="block py-2 pr-4 pl-3 text-white md:p-0"
                            :class="[
                                $route.path == '/'
                                    ? ' md:underline underline-offset-[9px] decoration-[2px] decoration-secondary text-secondary'
                                    : '',
                            ]"
                            aria-current="page"
                            >Dashboard</a
                        >
                    </li>
                    <li>
                        <a
                            href="/campaigns"
                            class="block py-2 pr-4 pl-3 text-white md:p-0"
                            :class="[
                                $route.path == '/campaigns' || $route.path == '/add-campaign'
                                    ? ' md:underline underline-offset-[9px] decoration-[2px] decoration-secondary text-secondary'
                                    : '',
                            ]"
                            >Campaigns</a
                        >
                    </li>
                    <li>
                        <a
                            href="/reports"
                            class="block py-2 pr-4 pl-3 text-white md:p-0"
                            :class="[
                                $route.path == '/reports'
                                    ? ' md:underline underline-offset-[9px] decoration-[2px] decoration-secondary text-secondary'
                                    : '',
                            ]"
                            >Reports</a
                        >
                    </li>
                </ul>
            </div>
        </div>
    </nav>

    <!-- <header class="header bg-black shadow py-4 px-4">
    <div class="header-content flex items-center flex-row">
      <div class="flex ml-auto">
        <div class="f">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="83.6"
            height="44.857"
            viewBox="0 0 83.6 44.857"
          >
            <g
              id="dkilo_logo"
              data-name="dkilo logo"
              transform="translate(-40 -31.124)"
            >
              <g
                id="white_dkilo_logo"
                data-name="white dkilo logo"
                transform="translate(40 31.124)"
              >
                <g id="c">
                  <g id="Group_15925" data-name="Group 15925">
                    <g
                      id="Group_15922"
                      data-name="Group 15922"
                      transform="translate(25.466 5.216)"
                    >
                      <g
                        id="Group_15921"
                        data-name="Group 15921"
                        transform="translate(19.472 4.583)"
                      >
                        <rect
                          id="Rectangle_1838"
                          data-name="Rectangle 1838"
                          width="5.216"
                          height="5.216"
                          transform="translate(5.216) rotate(90)"
                          fill="#fff"
                        />
                        <path
                          id="Path_25624"
                          data-name="Path 25624"
                          d="M182.8,85.83v22.484H177.61V85.83Z"
                          transform="translate(-177.597 -73.907)"
                          fill="#fff"
                        />
                      </g>
                      <path
                        id="Path_25625"
                        data-name="Path 25625"
                        d="M213.633,20.61V59.6H208.44V20.61Z"
                        transform="translate(-181.152 -20.61)"
                        fill="#fff"
                      />
                      <path
                        id="Path_25626"
                        data-name="Path 25626"
                        d="M235.55,95.065a11.177,11.177,0,0,1,3.485-8.289,12.3,12.3,0,0,1,17.038.023,12.041,12.041,0,0,1-.023,16.921,11.91,11.91,0,0,1-8.61,3.394,11.381,11.381,0,0,1-8.473-3.462,11.645,11.645,0,0,1-3.417-8.587Zm5.31.091a7.586,7.586,0,0,0,1.8,5.333,7,7,0,0,0,9.744.023,8.44,8.44,0,0,0,0-10.483,6.341,6.341,0,0,0-4.872-1.984,6.233,6.233,0,0,0-4.824,1.984,7.22,7.22,0,0,0-1.848,5.125Z"
                        transform="translate(-201.401 -67.479)"
                        fill="#fff"
                      />
                      <path
                        id="Path_25627"
                        data-name="Path 25627"
                        d="M110.339,46.556l9.764-9.443H113.13l-7.317,7.271V20.61h-2.584v2.609H100.62V59.6h5.193V50.942l.833-.83,7.433,9.488h6.742l-10.48-13.044Z"
                        transform="translate(-100.62 -20.61)"
                        fill="#fff"
                      />
                    </g>
                    <g id="Group_15924" data-name="Group 15924">
                      <g
                        id="Group_15923"
                        data-name="Group 15923"
                        transform="translate(0 2.609)"
                      >
                        <path
                          id="Path_25628"
                          data-name="Path 25628"
                          d="M17.638,23.219V39.726a9.71,9.71,0,0,0-14.611.162A12.1,12.1,0,0,0,0,48.29a12.674,12.674,0,0,0,3.024,8.59,9.889,9.889,0,0,0,7.663,3.371,9.689,9.689,0,0,0,6.95-3V59.6h5.219V25.826H20.247V23.217H17.638Zm-1.453,30.4a5.964,5.964,0,0,1-4.664,1.987,5.68,5.68,0,0,1-4.48-2.055A7.836,7.836,0,0,1,5.31,48.29a7.489,7.489,0,0,1,1.779-5.079,5.74,5.74,0,0,1,4.48-2.03,5.868,5.868,0,0,1,4.616,2.01,7.687,7.687,0,0,1,1.777,5.216,7.694,7.694,0,0,1-1.777,5.219ZM22.856,20.61H20.247v2.609h2.609Z"
                          transform="translate(0 -18.003)"
                          fill="#369da3"
                        />
                        <rect
                          id="Rectangle_1839"
                          data-name="Rectangle 1839"
                          width="2.609"
                          height="2.609"
                          transform="translate(17.638)"
                          fill="#369da3"
                        />
                        <rect
                          id="Rectangle_1840"
                          data-name="Rectangle 1840"
                          width="2.609"
                          height="2.609"
                          transform="translate(22.856)"
                          fill="#369da3"
                        />
                      </g>
                      <rect
                        id="Rectangle_1841"
                        data-name="Rectangle 1841"
                        width="2.609"
                        height="2.609"
                        transform="translate(28.075)"
                        fill="#369da3"
                      />
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </svg>
        </div>

        <div class="test rounded-full">
          <span class="flex items-center justify-center pt-3"> EG </span>
        </div>
      </div>
    </div>
  </header> -->
</template>
<script>
import { mapGetters } from "vuex";
import router from "../../../router/router";
export default {
    data() {
        return {
            user: "",
            isOptionsExpanded: false,
            // selectedOption: "Profile",
            options: ["Profile", "Log out"],
        };
    },
    methods: {
        goTo() {
            router.push("/support");
        },
        setOption(option) {
            // console.log("op", option);
            this.isOptionsExpanded = false;
            if (option == "Profile") {
                router.push("/Profile");
            } else {
                this.$store.dispatch("logout");
            }
        },
    },
    computed: {
        isUser() {
            return localStorage.getItem("user");
        },
        isfirstName() {
            return localStorage.getItem("firstName");
        },
    },
};
</script>
<style>
/* .test {
  top: 13px;
  left: 1274px;
  width: 55px;
  height: 55px;
  background: #eeeeee 0% 0% no-repeat padding-box;
  opacity: 1;
} */
</style>
